// extracted by mini-css-extract-plugin
export var arrowDown = "BetPick-module--arrowDown--de40e";
export var arrowUp = "BetPick-module--arrowUp--ae6c6";
export var back = "BetPick-module--back--bb23f";
export var blue = "#0eb3f2";
export var button = "BetPick-module--button--8f04b";
export var buttons = "BetPick-module--buttons--4e16c";
export var clamp = "BetPick-module--clamp--34681";
export var close = "BetPick-module--close--4e78a";
export var container = "BetPick-module--container--48594";
export var content = "BetPick-module--content--dfadf";
export var down = "BetPick-module--down--c0de2";
export var emphasis = "BetPick-module--emphasis--624c9";
export var enter = "BetPick-module--enter--a0ff7";
export var eventName = "BetPick-module--eventName--98bbf";
export var eventNamePickSlip = "BetPick-module--eventNamePickSlip--232fd";
export var exoticTitle = "BetPick-module--exoticTitle--9a9af";
export var footer = "BetPick-module--footer--82657";
export var green = "#57d33b";
export var greenLink = "BetPick-module--green-link--7572d";
export var grey = "var(--tone-mid)";
export var header = "BetPick-module--header--2c3e6";
export var hidden = "BetPick-module--hidden--2f3f4";
export var icon = "BetPick-module--icon--4287d";
export var iconButton = "BetPick-module--iconButton--4ce09";
export var info = "BetPick-module--info--3948a";
export var isReviewing = "BetPick-module--isReviewing--ad8a7";
export var label = "BetPick-module--label--3c2eb";
export var largeFooter = "BetPick-module--largeFooter--65abc";
export var lockIcon = "BetPick-module--lockIcon--14d45";
export var marketName = "BetPick-module--marketName--1e198";
export var matchInfo = "BetPick-module--matchInfo--5d8c3";
export var notchGap = "32px";
export var oddsWrapper = "BetPick-module--oddsWrapper--a0b2f";
export var oldOdds = "BetPick-module--oldOdds--e169b";
export var orange = "#f8662b";
export var outcomeIcon = "BetPick-module--outcomeIcon--527f8";
export var panel = "BetPick-module--panel--3910b";
export var pickContent = "BetPick-module--pickContent--6ccf6";
export var pickIcon = "BetPick-module--pickIcon--238c8";
export var red = "#ff2741";
export var right = "BetPick-module--right--6b0bd";
export var scrollArea = "BetPick-module--scrollArea--8782f";
export var selectionName = "BetPick-module--selectionName--01a8b";
export var small = "BetPick-module--small--62f36";
export var smallFooter = "BetPick-module--smallFooter--cc4bf";
export var starts = "BetPick-module--starts--a2f00";
export var statusWithStream = "BetPick-module--statusWithStream--22d59";
export var tab = "BetPick-module--tab--d1a30";
export var tabList = "BetPick-module--tabList--fe0ce";
export var tabListContainer = "BetPick-module--tabListContainer--02eb2";
export var tabs = "BetPick-module--tabs--0482b";
export var title = "BetPick-module--title--a7364";
export var trash = "BetPick-module--trash--af479";
export var up = "BetPick-module--up--92987";
export var value = "BetPick-module--value--ecaf7";
export var widthDesktop = "1024px";
export var widthDesktopXl = "1280px";
export var widthExpanded = "1536px";
export var widthMobile = "640px";
export var widthTablet = "768px";
export var yellow = "#ffb100";